// API host és (opcionális) kulcs-mapping: appKulcs -> szerverKulcs
export const API_REGISTRY = {
  'API-002': {
    baseUrl: '',   // üres => REACT_APP_API_BASE || window.location.origin || https://hacsi.hu
    map: { /* szükség esetén: HE_lamp_kert: 'SZ_lamp_1' */ },
  },
  'API-005': {
    baseUrl: '',
    map: { Relay: 'Relay' }, // jelenleg nincs eltérés, de itt kezelhető
  },
};
